import { Spin } from 'antd';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMe, useUserStore } from '@entities/user';
import { rememberReturnTo } from './returnTo';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Гард приватных маршрутов кабинета.
 *
 * 1. В сторе есть user — рендерим.
 * 2. Иначе ждём /user/ (по cookies; при протухшем access httpClient сам делает refresh).
 *    Спиннер — пока запрос не завершился. Раньше на первом кадре запрос ещё «не шёл»,
 *    гард сразу уводил на /login, а оттуда — в список ассистентов: так прямая ссылка
 *    и обновление страницы внутри ассистента «выкидывали» (ошибка фич-листа № 25).
 * 3. Запрос завершился ошибкой — на /login, запомнив адрес, чтобы вернуть после входа.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation();
  const user = useUserStore((s) => s.user);
  const meQuery = useMe({ enabled: !user });

  if (user) {
    return <>{children}</>;
  }

  if (!meQuery.isError) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const from = location.pathname + location.search;
  rememberReturnTo(from);
  return <Navigate to="/login" replace state={{ from }} />;
}
